import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  search: null,
  date_from: null,
  date_to: null,
  likes: null,
  shares: null,
  views: null,
  comments: null,
  reposts: null,
  replies: null,
  dislikes: null,
  gender: null,
  user_type: null,
  sentiment: null,
  rating: null,
  emotion: null,
};

const filterPanelSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilterPanel: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetFilterPanel: () => initialState,
  },
});
const { reducer, actions } = filterPanelSlice;

export const { setFilterPanel, resetFilterPanel } = actions;
export default reducer;
